// extracted by mini-css-extract-plugin
module.exports = {"model-header":"style_model-header__23nsS","icon":"style_icon__3HOqw","header-content":"style_header-content__7XOfx","title":"style_title__3hUxU"};